export enum PageType {
    List = "list", //in case when user opens “Nabídka” page with many bets
    Detail = "detail", //in case when user opens detail of one match
    Other = "other", //in case when user opens any other page (when page isn't list nor detail)
    ListSearch = "list.searchresults", //in case user opens search
}

export enum PageTheme {
    Light = "light",
    Dark = "dark",
}

export enum PageResponseDesignCategory {
    DesktopLarge = "desktop-large",
    Desktop = "desktop",
    Laptop = "laptop",
    Mobile = "mobile",
    Tablet = "tablet",
    Unkwnown = "unknown",
}
